import React from "react";
import "../styles/AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-container">
      <h1>About HirePro</h1>
      <p>
        At <strong>HirePro</strong>, we bridge the gap between job seekers and top companies. 
        Our mission is to create a seamless, efficient, and engaging job search experience.
      </p>

      <h2>Why Choose Us?</h2>
      <ul>
        <li>🏆 <strong>Top Job Listings:</strong> Get access to premium job opportunities.</li>
        <li>🤝 <strong>Company Insights:</strong> Learn about your future workplace.</li>
        <li>🚀 <strong>Career Growth:</strong> Resume tips, interview guidance, and mentorship.</li>
      </ul>

      <h2>Our Vision</h2>
      <p>
        We envision a world where job seekers can easily connect with companies based on skills, 
        culture, and long-term growth potential.
      </p>
    </div>
  );
};

export default AboutUs;
